import i18n from '../../i18n/i18n'

const state = {
  messages : {
    NotAllowedError: i18n.t('messagebox.NotAllowedError'),
    NotFoundError: i18n.t('messagebox.NotFoundError'),
    NotSupportedError: i18n.t('messagebox.NotSupportedError'),
    InsecureContextError: i18n.t('messagebox.InsecureContextError'),
    NotReadableError: i18n.t('messagebox.NotReadableError'),
    OverconstrainedError: i18n.t('messagebox.OverconstrainedError'),
    ECONNABORTED: i18n.t('messagebox.ECONNABORTED'),
    RegisterError: i18n.t('messagebox.RegisterError'),
    AlreadyApiary: i18n.t('messagebox.AlreadyApiary'),
        
    88: i18n.t('messagebox.88'),
    89: i18n.t('messagebox.89'),
      
    90: i18n.t('messagebox.90'),
      
    98: i18n.t('messagebox.98'),
    99: i18n.t('messagebox.99'),
    100: i18n.t('messagebox.100'),
    101: i18n.t('messagebox.101'),
    102: i18n.t('messagebox.102'),
    105: i18n.t('messagebox.105'),
      
    400: i18n.t('messagebox.400'),
    500: i18n.t('messagebox.500'),
    404: i18n.t('messagebox.404'),
    409: i18n.t('messagebox.409'),
    401: i18n.t('messagebox.401'),
      
    1000: i18n.t('messagebox.1000'),
    1002: i18n.t('messagebox.1002'),
    1003: i18n.t('messagebox.1003'),
    1004: i18n.t('messagebox.1004'),
    1005: i18n.t('messagebox.1005'),
    1006: i18n.t('messagebox.1006'),
    1007: i18n.t('messagebox.1007'),
      
    4000: i18n.t('messagebox.4000'),
    4001: i18n.t('messagebox.4001'),
    4002: i18n.t('messagebox.4002'),
    4003: i18n.t('messagebox.4003'),
    4004: i18n.t('messagebox.4004'),
    4005: i18n.t('messagebox.4005'),
    4030: i18n.t('messagebox.4030'),
    4031: i18n.t('messagebox.4031'),
    4080: i18n.t('messagebox.4080'),
    4081: i18n.t('messagebox.4081'),
    4082: i18n.t('messagebox.4082'),
      
    2001: i18n.t('messagebox.2001'),
    2002: i18n.t('messagebox.2002'),
    2003: i18n.t('messagebox.2003'),
      
    6001: i18n.t('messagebox.6001')
  }
}
const getters = {}
const mutations = {}
const actions = {
  errorMsg (store, error) {
    return new Promise((resolve) => {
      let errorMsg = ''
      if (Object.prototype.hasOwnProperty.call(error.response.data, 'code')) {
        if (Object.prototype.hasOwnProperty.call(state.messages, error.response.data.code)) {
          errorMsg = state.messages[error.response.data.code]
        } else {
          errorMsg = i18n.t('messagebox.ErrorMsg')
        }
      } else if (Object.prototype.hasOwnProperty.call(error.response.data, 'error_code')) {
        if (Object.prototype.hasOwnProperty.call(state.messages, error.response.data.error_code)) {
          errorMsg = state.messages[error.response.data.error_code]
        } else {
          errorMsg = i18n.t('messagebox.ErrorMsg')    
        }
      } else {
        errorMsg = i18n.t('messagebox.ErrorMsg')
      }
      resolve(errorMsg)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
  
